import { defineAsyncComponent } from 'vue'
import {
  ClipboardDocumentListIcon,
  HomeIcon,
  ArrowPathRoundedSquareIcon,
  ArrowsRightLeftIcon,
  RocketLaunchIcon,
  GlobeAltIcon,
  EnvelopeIcon,
  MagnifyingGlassCircleIcon,
  TagIcon,
  FunnelIcon,
  RectangleStackIcon,
  WindowIcon,
  UsersIcon,
  ChartBarIcon,
} from '@heroicons/vue/24/outline'

const mainNavigation = [
  { name: 'Dashboard', href: '/dashboard', icon: HomeIcon },
  { name: 'Preference Pages', href: '/preference-pages', icon: WindowIcon },
  { name: 'Customers', href: '/customers', icon: UsersIcon },
  { name: 'Analytics', href: '/analytics', icon: ChartBarIcon },
]

const configNavigation = [
  { name: 'Integrations', href: '/integrations', icon: ArrowPathRoundedSquareIcon },
  { name: 'Lists', href: '/lists', icon: ClipboardDocumentListIcon },
  { name: 'Actions', href: '/actions', icon: RocketLaunchIcon },
  { name: 'Migrations', href: '/migrations', icon: ArrowsRightLeftIcon },
]

// Backward compat
const navigation = [...mainNavigation, ...configNavigation]

const actionIcons = {
  global_unsubscribe: GlobeAltIcon,
  suppression_group: ClipboardDocumentListIcon,
  switch_email: EnvelopeIcon,
  webhook: RocketLaunchIcon,
  evidence: MagnifyingGlassCircleIcon,
  tag: TagIcon,
  funnel: FunnelIcon,
  list: ClipboardDocumentListIcon,
  automation: RectangleStackIcon,
}

const defaultLists = [
  {
    name: 'Sales',
    description: 'Can we email you if we have an incredible deal just for you?',
    subscription_default_state: true,
    translations: [],
  },
  {
    name: 'Newsletter',
    description: `We would love to keep you posted regarding the amazing things we're working on. Would you like to keep getting our newsletters?`,
    subscription_default_state: false,
    translations: [],
  },
]

function capitalize(val) {
  return val[0].toUpperCase() + val.slice(1)
}

const TEMPLATES = {
  default_preference_page: defineAsyncComponent(() => import('@/components/preference/templates/PreferencePage.vue')),
  stacked_marketer_template: defineAsyncComponent(() => import('@/components/preference/templates/StackedMarketer.vue')),
  checkbox_template: defineAsyncComponent(() => import('@/components/preference/templates/CheckboxTemplate.vue')),
  cosmic_template: defineAsyncComponent(() => import('@/components/preference/templates/CosmicTemplate.vue')),
  landing_template: defineAsyncComponent(() => import('@/components/preference/templates/LandingTemplate.vue')),
}

const TEMPLATE_NAMES = {
  default_preference_page: 'Classic',
  stacked_marketer_template: 'Stacked & Bold',
  checkbox_template: 'Checklist',
  cosmic_template: 'Cosmic',
  landing_template: 'Modern',
}

export { defaultLists, navigation, mainNavigation, configNavigation, actionIcons, capitalize, TEMPLATES, TEMPLATE_NAMES }
